import {CookieUtils} from 'Utils';

const languageSet = [
    {
        page: "system",
        languageList: [{
            zh: {
                search: "查询",
                reset: "重置",
                total: "共",
                row: "条"
            }
        },
            {
                en: {
                    search: "search",
                    reset: "reset",
                    total: "total",
                    row: "row"
                }
            }
        ]
    },
    {
        page: "login",
        languageList: [
            {
                zh: {
                    mail: "举报邮箱：",
                    tip: "注意",
                    tip1: "DMC渠道云系统无法兼容火狐浏览器，请及时更换，建议使用谷歌浏览器。",
                    loginFail: "登入失败",
                    loginSuccess: "登入成功",
                    title: "天正DMC渠道营销云系统",
                    userName: "请输入账号!",
                    userNameTip: "用户名/手机号码",
                    password: "请输入密码!",
                    passwordTip: "密码",
                    remember: "记住密码",
                    tip2: "扫码安装天正渠道云App",
                    company: "浙江天正电气股份有限公司",
                    loginbtn: "登入"
                }
            },
            {
                en: {
                    mail: "Report Mailbox：",
                    tip: "warn",
                    tip1: "The DMC channel cloud system is not compatible with Firefox browser. Please replace it in a timely manner. It is recommended to use Google Chrome browser.",
                    loginFail: "Login failed",
                    loginSuccess: "Login success",
                    title: "Tianzheng DMC System",
                    userName: "Please enter your account!",
                    userNameTip: "Username/Mobile Number",
                    password: "Please input a password!",
                    passwordTip: "password",
                    remember: "remember password",
                    tip2: "Scan code installation Tianzheng Channel Cloud App",
                    company: "Zhejiang Tianzheng Electric Co., Ltd",
                    loginbtn: "Login"
                }
            }
        ]
    },
    {
        page: "home",
        languageList: [
            {
                zh: {
                    tip: "注意：为保证系统操作最佳性能，推荐使用‘谷歌浏览器’",
                    gfcompany: "浙江天正电气股份有限公司",
                    tyxcompany: "上海天毅行智能电气有限公司",
                    businessLine: "选择当前业务线",
                    tip1: "请选择要添加到首页的功能",
                    tip2: "重要通知",
                    tip3: "根据天e战略规划要求，使用天e电气产品参与报价的，须提前通过天正电气进行项目报备。",
                    tip4: "未经项目报备参与报价的，一切法律责任由报价单位独立承担。",
                    tip5: "如有异议，请联系智能配电销售部。",
                }
            },
            {
                en: {
                    tip: "Attention: To ensure optimal system performance, it is recommended to use 'Google Chrome'",
                    gfcompany: "Zhejiang Tianzheng",
                    tyxcompany: "Shanghai Tianyi Xing",
                    businessLine: "Select the current business line",
                    tip1: "Please select the function to add to the homepage",
                    tip2: "Important Notice",
                    tip3: "According to the strategic planning requirements of Tian E, those who use Tian E electrical products to participate in the quotation must report the project through Tian Zheng Electric in advance.",
                    tip4: "Those who participate in the quotation without project reporting shall bear all legal responsibilities independently by the bidding unit.",
                    tip5: "If you have any objections, please contact the Intelligent Distribution Sales Department.",
                }
            }
        ]
    },
    {
        page: "app",
        languageList: [
            {
                zh: {
                    tip: "注意：为保证系统操作最佳性能，推荐使用‘谷歌浏览器’",
                    gfcompany: "浙江天正电气股份有限公司",
                    tyxcompany: "上海天毅行智能电气有限公司",
                    businessLine: "选择当前业务线",
                    tip1: "扫描二维码下载营销云App",
                    profile: "个人信息",
                    logout: "退出",
                    switch: "切换"
                }
            },
            {
                en: {
                    tip: "Attention: To ensure optimal system performance, it is recommended to use 'Google Chrome'",
                    gfcompany: "Zhejiang Tianzheng",
                    tyxcompany: "Shanghai Tianyi Xing",
                    businessLine: "Select the current business line",
                    tip1: "Scan the QR code to download the Marketing Cloud App",
                    profile: "Information",
                    logout: "logout",
                    switch: "switch"
                }
            }
        ]
    }
]

export default function setLanguageText(page, self) {
    let language = CookieUtils.get('language') || "zh";
    languageSet.map((item) => {
        if (item.page === page) {
            item.languageList.map((itm) => {
                if (language.toString() == "zh") {
                    if (itm.zh) {
                        self.setState({"languageSet": itm.zh});
                    }
                } else {
                    if (itm.en) {
                        self.setState({"languageSet": itm.en});
                    }
                }
            })
        }
    })
}




// WEBPACK FOOTER //
// ./src/utils/languageSet.js